const navbarGradient: object = {
  transparent: {
    background: 'bg-transparent',
    color: 'text-blue-gray-900',
    boxShadow: 'shadow-none',
  },
  white: {
    background: 'bg-white',
    color: 'text-blue-gray-900',
  },
  'blue-gray': {
    background: 'bg-gradient-to-tr from-blue-gray-600 to-blue-gray-400',
    color: 'text-white',
  },
  gray: {
    background: 'bg-gradient-to-tr from-gray-600 to-gray-400',
    color: 'text-white',
  },
  brown: {
    background: 'bg-gradient-to-tr from-brown-600 to-brown-400',
    color: 'text-white',
  },
  'deep-orange': {
    background: 'bg-gradient-to-tr from-deep-orange-600 to-deep-orange-400',
    color: 'text-white',
  },
  orange: {
    background: 'bg-gradient-to-tr from-orange-600 to-orange-400',
    color: 'text-white',
  },
  amber: {
    background: 'bg-gradient-to-tr from-amber-600 to-amber-400',
    color: 'text-black',
  },
  yellow: {
    background: 'bg-gradient-to-tr from-yellow-600 to-yellow-400',
    color: 'text-black',
  },
  lime: {
    background: 'bg-gradient-to-tr from-lime-600 to-lime-400',
    color: 'text-black',
  },
  'light-green': {
    background: 'bg-gradient-to-tr from-light-green-600 to-light-green-400',
    color: 'text-white',
  },
  green: {
    background: 'bg-gradient-to-tr from-green-600 to-green-400',
    color: 'text-white',
  },
  teal: {
    background: 'bg-gradient-to-tr from-teal-600 to-teal-400',
    color: 'text-white',
  },
  cyan: {
    background: 'bg-gradient-to-tr from-cyan-600 to-cyan-400',
    color: 'text-white',
  },
  'light-blue': {
    background: 'bg-gradient-to-tr from-light-blue-600 to-light-blue-400',
    color: 'text-white',
  },
  blue: {
    background: 'bg-gradient-to-tr from-blue-600 to-blue-400',
    color: 'text-white',
  },
  indigo: {
    background: 'bg-gradient-to-tr from-indigo-600 to-indigo-400',
    color: 'text-white',
  },
  'deep-purple': {
    background: 'bg-gradient-to-tr from-deep-purple-600 to-deep-purple-400',
    color: 'text-white',
  },
  purple: {
    background: 'bg-gradient-to-tr from-purple-600 to-purple-400',
    color: 'text-white',
  },
  pink: {
    background: 'bg-gradient-to-tr from-pink-600 to-pink-400',
    color: 'text-white',
  },
  red: {
    background: 'bg-gradient-to-tr from-red-600 to-red-400',
    color: 'text-white',
  },
};

export default navbarGradient;
